<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="6">
          <b-card no-body class="mx-6">
            <b-card-body class="p-6">
              <b-form>
                <img src="customers/avo/logo_branco.jpg" width="500">
                <h2>IMPULSIONE SEU NEGÓCIO!</h2>
                <h3></h3>
                <p class="text-muted">O Clube Amigos que Valem Ouro é uma comunidade de networking e negócios para empresários, profissionais liberais, autônomos e empreendedores em geral.<br>
Além do networking, ganhos financeiros e capacitação empresarial, você encontrará um ambiente perfeito para a troca de experiências, conhecimentos e muitas oportunidades de negócios e parcerias.<br>
Não perca tempo! Junte-se ao Clube Amigos que Valem Ouro agora mesmo e dê um impulso significativo aos seus negócios.</p>

              
                <h5>Dados Pessoais</h5>
                <hr>
                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      label=""
                      label-for="name"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text><i class="icon-wallet"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input  v-model="name" ref="name" type="text" class="form-control text-uppercase" :class="nameField" required placeholder="Nome completo" autocomplete="name"                       
                        />
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>

                <!--
                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      :description="emailError"
                      label=""
                      label-for="email"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text>@</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input v-model="email" ref="email" type="text" class="form-control" :class="emailField" required placeholder="E-mail" autocomplete="email" 
                        @blur="checkEmail()"/>
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>
                -->

                <b-row>
                  <b-col md="12">


                    <b-form-group 
                      label=""
                      label-for="phone"
                      :label-cols="0"
                      :horizontal="false">
                    <b-input-group>
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class='fa fa-phone'></i>
                        </span>
                      </div>
                      <masked-input
                        type="tel"
                        name="phone"
                        class="form-control"
                        :class="phoneField"
                        v-model="phone"
                        :mask="['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                        :guide="true"
                        placeholderChar="_"
                        aria-placeholder="Telefone (Whatsapp)">
                      </masked-input>
                    </b-input-group>
                  </b-form-group>

                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      label=""
                      label-for="company"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text><i class="icon-briefcase"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input  v-model="company" ref="company" type="text" class="form-control text-uppercase" :class="companyField" required placeholder="Nome da sua Empresa"   />
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>

                <h5>Dados do Usuário</h5>
                <hr>

                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      :description="usernameError"
                      label=""
                      label-for="username"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input  v-model="username" ref="username" type="text" class="form-control" :class="usernameField" required placeholder="E-mail" autocomplete="username" 
                          @blur="checkUsername()" />
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      :description="passwordError"
                      label=""
                      label-for="passord"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input v-model="password" ref="password" type="password" :class="passwordField" class="form-control" required placeholder="Senha" 
                        @blur="checkPassword()"  />
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      :description="password2Error"
                      label=""
                      label-for="password2"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-4">
                        <b-input-group-prepend>
                          <b-input-group-text><i class="icon-lock-open"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input v-model="password2" ref="password2" type="password" class="form-control" :class="password2Field" required placeholder="Confirmar senha" 
                        @blur="checkPassword()"  />
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>

                <h5>Indicação</h5>
                <hr>

                <b-row>
                  <b-col md="12">
                
                    <b-form-group
                      description="Se você foi convidado, informe o nome da pessoa que te convidou"
                      label=""
                      label-for="recommendation"
                      :label-cols="0"
                      :horizontal="false">
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text><i class="icon-compass"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input  v-model="recommendation" ref="recommendation" type="text" class="form-control text-uppercase" required placeholder="Nome de quem indicou" />
                      </b-input-group>
                    </b-form-group>          

                  </b-col>
                </b-row>


                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label=""
                      label-for="termAccept"
                      :label-cols="3"
                      :horizontal="true">
                      <input id="termAccept" type="checkbox" value="" v-model="termAccept"> Aceito os termos e condições de uso
                    
                    </b-form-group>  

                    </b-form>
                  </b-col>
                </b-row>
                

                <b-row>
                  <b-col cols="3"></b-col>
                  <b-col cols="6">
                    <b-button block class="btn btn-linkedin" type="button" @click="openTermModal"><span>Termos e Condições de Uso</span></b-button>
                  </b-col>
                  <b-col cols="3"></b-col>
                </b-row>

                
                <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.errormessage && this.errormessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errormessage }}</div>
                </b-input-group>

                <!--
                <b-button variant="success" block>Criar Conta</b-button>
                -->
              </b-form>
            </b-card-body>
            <b-card-footer class="p-4">
              <b-row>
                <b-col cols="6">
                  <b-button block class="btn btn-facebook" @click="backLogin"><span>Voltar</span></b-button>
                </b-col>

                <b-col cols="6">
                  <b-button block class="btn btn-twitter" type="button" @click="createAccount" :disabled="!termAccept"><span>Criar Conta</span></b-button>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal v-model="termModal"
              id="term-modal"
              centered
              hide-footer
              title="Termos e Condições de Uso"
              size="lg">
      <user-terms-avo></user-terms-avo>
    </b-modal>

  </div>
</template>

<script>

import axios from "axios";
import MaskedInput from 'vue-text-mask'
import UserTermsAvo from './UseTermsAvo.vue'

export default {
  name: 'Register',
  components: {
    MaskedInput,
    UserTermsAvo
  },
  data: function() {
    return {
      passwordPolicy: /^.{8,}$/,
      passwordPolicyMessage: 'No mínimo 8 caracteres',

      errormessage: '',
      
      recommendation: '',

      company: '',
      companyField: '',
      
      name: '',
      nameField: '',
      
      phone: '',
      phoneField: '',

      usernameLastCheck: '',
      username: '',
      usernameError: '',
      usernameField: '',

      /*
      email: '',
      emailError: '',
      emailField: '',
      */
     
      password: '',
      passwordError: '',
      passwordField: '',

      password2: '',
      password2Error: '',
      password2Field: '',

      termAccept: false,
      termModal: false
    }
  },

  methods: {
    openTermModal() {
        this.termModal = true
    },

    async saveNewAccount() {
      var s = this;
      this.errormessage = '';
      var data = {
            companyId: s.$store.state.config.companyId,
            username: this.username,
            companyName: this.company,
            name: this.name,
            email: this.username,
            password: this.password,
            phone: this.phone,
            recommendation: this.recommendation
          }

      await axios.post(
          this.$store.state.ws_url + "/franchise/register",
          data          
      ).then(function(resp) {
        s.password = "";
        s.password2 = "";
        s.errormessage = 'Usuário criado com sucesso. Você receberá um e-mail com informações do cadastro.'
        //console.log(resp)
      })
      .catch(function (error) {
        console.log(error)
        s.errormessage = error.response.data.message;
      });

    },

    async checkUsername() {

      var s = this
      
      if(this.username && this.username.length > 0) {
        if(this.username != this.usernameLastCheck) {
          if(this.username.length > 3 && this.$utils.checkEmail(this.username)) {
            console.log(s.$store.state.ws_url + "/user/check/username/" + s.username)

            await axios.get(
              s.$store.state.ws_url + "/user/check/username/" + s.username
            ).then(function(resp) {
              //console.log(resp)
              s.usernameField = resp.data.obj > 0 ? 'is-invalid' : ''
              s.usernameError = resp.data.obj > 0 ? resp.data.message : ''

            }).catch(function(error) {
              s.usernameError = ''
              s.usernameField = ''
            })
          }
          else {
            s.usernameField = 'is-invalid'
            s.usernameError = 'E-mail inválido.'
          }
          this.usernameLastCheck = this.username
        }
      }
      else {
        s.usernameError = ''
        s.usernameField = ''
        s.usernameLastCheck = ''
      }

      
    
    },

    async checkEmail(emailToCheck, fieldError, fieldClass) {
      var s = this
      
      if(emailToCheck && emailToCheck.length > 0) {
        if(this.$utils.checkEmail(emailToCheck)) {
          await axios.get(
            this.$store.state.ws_url + "/user/check/email/" + emailToCheck
          ).then(function(resp) {
            //console.log(resp)
            fieldClass = resp.data.obj > 0 ? 'is-invalid' : ''
            fieldError = resp.data.obj > 0 ? resp.data.message : ''
            
          }).catch(function(error) {
            fieldClass = ''
            fieldError = ''
          })
        }
        else {
          fieldClass = 'is-invalid'
          fieldError = 'E-mail inválido. Verifique e tente novamente'
        }
      }
      else {
        fieldClass = ''
        fieldError = ''        
      }
    },

    checkPassword() {
      var s = this
      if(this.password && this.password.length > 0) {
        if(this.passwordPolicy.test(this.password)) {
          s.passwordField = ''
          s.passwordError = ''

          if(this.password2 && this.password2.length > 0) {
            s.password2Field = this.password === this.password2 ? '' : 'is-invalid'
            s.password2Error = this.password === this.password2 ? '' : 'Senhas diferentes. Verifique e tente novamente.'
          }
        }
        else {
          s.passwordField = 'is-invalid'
          s.passwordError = this.passwordPolicyMessage
        }
      }
      else {
        s.passwordField = ''
        s.passwordError = ''
      }
      
    },

    createAccount() {
      var containsError = false

      if(this.name == '') {
        this.nameField = 'is-invalid'
        containsError = true
      }
      else {
        this.nameField = ''
      }

      if(this.username == '') {
        this.usernameField = 'is-invalid'
        containsError = true
      }
      else {
        this.usernameField = ''
      }
      
      this.email = this.username
 
      if(this.email == '') {
        this.emailField = 'is-invalid'
        containsError = true
      }
      else {
        this.emailField = ''
      }

      if(this.phone == '') {
        this.phoneField = 'is-invalid'
        containsError = true
      }
      else {
        this.phoneField = ''
      }

      if(this.company == '') {
        this.companyField = 'is-invalid'
        containsError = true
      }
      else {
        this.companyField = ''
      }
      
      
      if(this.password == '') {
        this.passwordField = 'is-invalid'
        containsError = true
      }
      else {
        this.passwordField = ''
      }

      if(this.password2 == '') {
        this.password2Field = 'is-invalid'
        containsError = true
      }
      else {
        this.password2Field = ''
      }

      if(!containsError) {
        this.saveNewAccount()
      }      
    },

    backToPortal() {
      this.$router.push({ path: '/dashboard' })
    },
    backLogin() {
      this.$router.push({ path: '/pages/login' })
    },

    async getPreferences() {
      
      var s = this
      await axios.get(
        this.$store.state.ws_url + "/sys/preference/password/policy?companyId=" + this.$store.state.config.companyId
      ).then(function(resp) {
        s.passwordPolicy = new RegExp(resp.data.obj.stringPreference)
        s.passwordPolicyMessage = resp.data.obj.description
      }).catch(function(error) {
        s.passwordPolicy = /^.{8,}$/
      })
    }

  },


  mounted: function() {
      this.getPreferences()
  }

}
</script>
